module.exports = __webpack_public_path__ + "static/img/page2-main.330ba2c7.png";